/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowFamilyHealthDayTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowFamilyHealthDay,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Focus on Health as a Family!",
    "Family Health Day Awaits!",
    "Healthy Fun for Everyone!",
  ],
  title: "Family Health Day",
  description: "Organize a fun family health day.",
  longDescription:
    "Gather your family for an exciting health day! Choose a date, decide on activities, and plan healthy meals!",
  emoji: "🥗",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Family Health Day",
          emoji: "🥗",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the family health day?",
          emoji: "📅",
          completeAction: {
            question: "Decide on activities to include?",
            description: "What activities should we focus on during the day?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What activities should we consider?",
                emoji: "🏃",
                completeAction: {
                  question: "Decide on meals?",
                  description: "What healthy meals should we plan for the day?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What meals should we bring?",
                      emoji: "🥦",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Focus on Health Together!",
    outroDescription: "Your family health day plans are set! Enjoy the fun!",
  },
};
